import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "q-pa-md" };
const _hoisted_2 = { class: "text-h4 text-bold text-green-7" };
const _hoisted_3 = {
    key: 0,
    class: "text-green-7"
};
const _hoisted_4 = {
    key: 0,
    class: "q-pa-md q-mb-sm responsive-back-img"
};
const _hoisted_5 = { class: "row q-mb-lg" };
const _hoisted_6 = {
    class: "text-h6 text-bold",
    style: { "white-space": "pre-wrap" }
};
const _hoisted_7 = { class: "q-pa-md" };
const _hoisted_8 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_breadcrumb_list = _resolveComponent("breadcrumb-list");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_q_avatar = _resolveComponent("q-avatar");
    const _component_q_chip = _resolveComponent("q-chip");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_card_actions = _resolveComponent("q-card-actions");
    const _component_q_page = _resolveComponent("q-page");
    return (_openBlock(), _createBlock(_component_q_page, { class: "col column no-wrap" }, {
        default: _withCtx(() => [
            _createVNode(_component_breadcrumb_list, {
                breadCrumbs: [
                    { itemId: _ctx.PageID.top },
                    ...(_ctx.isMultipleKeiyaku
                        ? [{ itemId: _ctx.PageID.taikyoRoomList }]
                        : []),
                    { itemId: _ctx.PageID.taikyoFlowGuide },
                ]
            }, null, 8, ["breadCrumbs"]),
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_q_card, null, {
                    default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "bg-white" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.pageName), 1),
                                (_ctx.isParking)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, "※月極駐車場（〇〇〇駐車場、〇〇〇パーキング）の退去申請となります。"))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_separator),
                        (_ctx.flowItems.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.flowItems, (item) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: item.number,
                                            class: "col-6 col-xs-12 col-sm-6 col-md-3 q-pa-md"
                                        }, [
                                            _createVNode(_component_q_card, { class: "cursor-pointer q-pa-sm" }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_q_chip, null, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_q_avatar, {
                                                                color: "green-7",
                                                                "text-color": "white"
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(item.number), 1)
                                                                ]),
                                                                _: 2
                                                            }, 1024)
                                                        ]),
                                                        _: 2
                                                    }, 1024),
                                                    _createVNode(_component_q_card_section, { class: "text-center" }, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1024)
                                                ]),
                                                _: 2
                                            }, 1024)
                                        ]));
                                    }), 128))
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("div", { innerHTML: _ctx.html }, null, 8, _hoisted_8)
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_card_actions, {
                            class: "q-pb-lg",
                            align: "center"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_q_btn, {
                                    size: "lg",
                                    label: "進む",
                                    color: "green-7",
                                    "icon-right": "navigate_next",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.onClick()))
                                })
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                })
            ])
        ]),
        _: 1
    }));
}
